import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerOrderView = () => {
  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');
  const [orderId, setOrderId] = useState(0);
  const [order, setOrder] = useState(null);
  const [orderItems, setOrderItems] = useState([]);
  const [delivery, setDelivery] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const id = Number(new URLSearchParams(window.location.search).get('id') || 0);

        const res = await axios.get(
          `/api/seller/order/view-data?id=${encodeURIComponent(id)}`,
          { withCredentials: true }
        );

        if (res.data && res.data.ok) {
          setShopName(res.data.shop_name || '');
          setOrderId(res.data.order_id || 0);
          setOrder(res.data.order || null);
          setOrderItems(Array.isArray(res.data.order_items) ? res.data.order_items : []);
          setDelivery(res.data.delivery || null);
        } else {
          alert(res.data?.error || '주문 정보를 불러오지 못했습니다.');
        }
      } catch (err) {
        const redirect = err?.response?.data?.redirect;
        const error = err?.response?.data?.error;
        if (redirect) {
          window.location.href = redirect;
          return;
        }
        alert(error || '주문 정보를 불러오지 못했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const formatNumber = (n) => Number(n || 0).toLocaleString('ko-KR');

  {/* 가격 */}
  const optionTotalPrice = orderItems.reduce((sum, item) => {
    return (
      sum +
      Number(item.option_total || 0) *
        Number(item.quantity || 0)
    );
  }, 0);
  
  // 주문 당시 세일 적용 후 상품금액 + 옵션금액
  const discountedSubtotal =
    Number(order?.total_price || 0);
  
  // 주문 당시 상품 세일 할인금액
  const productDiscountAmount =
    Number(order?.product_discount_amount || 0);
  
  // 할인 전 상품금액 + 옵션금액
  const originalSubtotal =
    discountedSubtotal + productDiscountAmount;
  
  // 옵션을 제외한 순수 상품 정상금액
  const productOriginalPrice =
    originalSubtotal - optionTotalPrice;
  
  const couponDiscountAmount =
    Number(order?.discount_amount || 0);
  
  const displayDeliveryCost =
    Number(order?.delivery_cost || 0);
  
  const finalPaymentPrice =
    Number(order?.result_price || 0);

  const paymentStatusView = () => {
    const orderStatus = order?.status || '';
  
    if (orderStatus === '주문취소') {
      return (
        <>
          <span style={styles.badgeDanger}>주문취소</span>{' '}
          <button
            type="button"
            onClick={handleReceipt}
            style={styles.inlineLinkBtn}
          >
            [영수증 상세정보]
          </button>
        </>
      );
    }
  
    return (
      <>
        <span style={styles.badgeSuccess}>결제완료</span>{' '}
        <button
          type="button"
          onClick={handleReceipt}
          style={styles.inlineLinkBtn}
        >
          [영수증 상세정보]
        </button>
      </>
    );
  };

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loading}>로딩중...</div>
      </SellerLayout>
    );
  }

  if (!order) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loading}>주문이 없습니다.</div>
      </SellerLayout>
    );
  }

  const handleCancelOrder = async () => {

    if (!window.confirm('정말 결제를 취소하시겠습니까?')) {
      return;
    }
  
    try {
  
      const res = await axios.post(
        '/api/pay/seller/cancel',
        {
          cancel_order_id: order.paymentkey,
          cancel_id: order.id
        },
        {
          withCredentials: true
        }
      );
  
      if (res.data.success) {
        alert(res.data.message);
  
        // 화면 갱신
        window.location.reload();
      } else {
        alert(res.data.message || '결제 취소에 실패했습니다.');
      }
  
    } catch (err) {
  
      alert(
        err?.response?.data?.message ||
        '결제 취소에 실패했습니다.'
      );
  
    }
  };

  const handleReceipt = async () => {

    try {
  
      const res = await axios.post(
        '/api/pay/seller/receipt',
        {
          paykey: order.paymentkey
        },
        {
          withCredentials: true
        }
      );
  
      if (!res.data.success) {
        alert(res.data.message || '영수증 조회 실패');
        return;
      }
  
      const receiptUrl = res.data.receipt_url;
  
      if (!receiptUrl) {
        alert('영수증 URL이 없습니다.');
        return;
      }
  
      window.open(
        receiptUrl,
        '_blank',
        'width=900,height=900'
      );
  
    } catch (err) {
  
      alert(
        err?.response?.data?.message ||
        '영수증 조회 실패'
      );
  
    }
  };

  return (
    <SellerLayout shopName={shopName}>
      <div style={styles.wrap}>
        <h1 style={styles.pageTitle}>주문 상세 (ID: {order.id})</h1>

        <h3 style={styles.sectionTitle}>기본 정보</h3>
        <table style={styles.infoTable}>
          <tbody>
            <tr><th style={styles.th100}>주문자</th><td style={styles.td}>{order.buyer_name || ''}</td></tr>
            <tr><th style={styles.th100}>전화번호</th><td style={styles.td}>{order.buyer_phone || ''}</td></tr>
            <tr><th style={styles.th100}>결제수단</th><td style={styles.td}>{order.payment_method || ''}</td></tr>
            <tr><th style={styles.th100}>총액</th><td style={styles.td}>{formatNumber(order.result_price)}원</td></tr>
            <tr><th style={styles.th100}>주문일</th><td style={styles.td}>{order.order_date}</td></tr>
            <tr><th style={styles.th100}>결제상태</th><td style={styles.td}>{paymentStatusView()}</td></tr>

            {(order.status || '') === '결제완료' ? (
              <tr>
                <th style={styles.th100}>결제취소</th>
                <td style={styles.td}>
                  <button
                    type="button"
                    onClick={handleCancelOrder}
                    style={styles.inlineLinkBtn}
                  >
                    [결제취소요청]
                  </button>
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>

        <h3 style={styles.sectionTitle}>주문 상품</h3>
        <table style={styles.infoTable}>
          <thead>
            <tr>
              <th style={styles.th100}>상품 ID</th>
              <th style={styles.theadTh}>상품명</th>
              <th style={styles.theadTh}>수량</th>
              <th style={styles.theadTh}>단가</th>
            </tr>
          </thead>
          <tbody>
            {orderItems.map((item, idx) => (
              <tr key={idx}>
                <td style={styles.td}>{item.product_id}</td>
                <td style={styles.tdLeft}>
                  {item.product_image ? (
                    <img
                      src={`/static/${String(item.product_image).replace(/^\/+/, '')}`}
                      alt={item.product_name || ''}
                      style={styles.productThumb}
                    />
                  ) : (
                    <img
                      src="/static/default_thumb.jpg"
                      alt={item.product_name || ''}
                      style={styles.productThumb}
                    />
                  )}
                  <a
                    href={`/seller/product/view?id=${item.product_id}`}
                    style={styles.productLink}
                  >
                    {item.product_name || ''}
                  </a>

                  {item.options?.length > 0 && (
                    <div style={styles.optionBox}>
                      {item.options.map((opt, optIdx) => (
                        <div key={optIdx} style={styles.optionText}>
                          {opt.option_group_name}: {opt.option_item_name}
                          {Number(opt.option_price || 0) > 0 &&
                            ` (+${Number(opt.option_price || 0).toLocaleString()}원)`
                          }
                        </div>
                      ))}
                    </div>
                  )}

                </td>
                <td style={styles.td}>{item.quantity}</td>
                <td style={styles.td}>{formatNumber(item.price)}원</td>
              </tr>
            ))}
          </tbody>
        </table>

        <h3 style={styles.sectionTitle}>결제금액</h3>

        <table style={styles.infoTable}>
          <tbody>
            <tr>
              <th style={styles.th100}>상품금액</th>
              <td style={styles.td}>
                {formatNumber(productOriginalPrice)}원
              </td>
            </tr>

            {optionTotalPrice > 0 && (
              <tr>
                <th style={styles.th100}>옵션금액</th>
                <td style={styles.td}>
                  +{formatNumber(optionTotalPrice)}원
                </td>
              </tr>
            )}

            <tr>
              <th style={styles.th100}>상품할인</th>
              <td style={styles.td}>
                -{formatNumber(productDiscountAmount)}원
              </td>
            </tr>

            <tr>
              <th style={styles.th100}>쿠폰할인</th>
              <td style={styles.td}>
                -{formatNumber(couponDiscountAmount)}원
              </td>
            </tr>

            <tr>
              <th style={styles.th100}>배송료</th>
              <td style={styles.td}>
                +{formatNumber(displayDeliveryCost)}원
              </td>
            </tr>

            <tr>
              <th style={styles.th100}>최종 결제금액</th>
              <td
                style={{
                  ...styles.td,
                  fontWeight: '700',
                  fontSize: '16px',
                }}
              >
                {formatNumber(finalPaymentPrice)}원
              </td>
            </tr>
          </tbody>
        </table>

        <h4 style={styles.sectionTitle}>배송 정보</h4>
        <table style={styles.infoTable}>
          <tbody>
            <tr><th style={styles.th100}>수령인</th><td style={styles.td}>{delivery ? (delivery.receiver_name || '-') : '-'}</td></tr>
            <tr><th style={styles.th100}>전화번호</th><td style={styles.td}>{delivery ? (delivery.receiver_phone || '-') : '-'}</td></tr>
            <tr>
              <th style={styles.th100}>주소</th>
              <td
                style={styles.td}
                dangerouslySetInnerHTML={{
                  __html: String(delivery ? (delivery.address || '-') : '-').replace(/\n/g, '<br>')
                }}
              />
            </tr>
            <tr>
              <th style={styles.th100}>배송메모</th>
              <td
                style={styles.td}
                dangerouslySetInnerHTML={{
                  __html: String(delivery ? (delivery.delivery_note || '-') : '-').replace(/\n/g, '<br>')
                }}
              />
            </tr>
            <tr><th style={styles.th100}>운송장번호</th><td style={styles.td}>{delivery ? (delivery.tracking_number || '-') : '-'}</td></tr>
            <tr><th style={styles.th100}>택배사</th><td style={styles.td}>{delivery ? (delivery.courier || '-') : '-'}</td></tr>
          </tbody>
        </table>

        <a href={`/seller/delivery/edit?order_id=${orderId}`} style={styles.primaryOutlineBtn}>
          배송정보 수정
        </a>
      </div>
    </SellerLayout>
  );
};

const styles = {
  loading: {
    padding: '40px 0',
  },
  wrap: {
    paddingTop: '8px',
    paddingBottom: '24px',
  },
  pageTitle: {
    marginBottom: '24px',
  },
  sectionTitle: {
    marginTop: '24px',
    marginBottom: '12px',
  },
  infoTable: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '16px',
  },
  th100: {
    width: '100px',
    border: '1px solid #dee2e6',
    padding: '12px',
    background: '#f8f9fa',
    textAlign: 'left',
    verticalAlign: 'middle',
  },
  theadTh: {
    border: '1px solid #dee2e6',
    padding: '12px',
    background: '#f8f9fa',
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  td: {
    border: '1px solid #dee2e6',
    padding: '12px',
    verticalAlign: 'middle',
  },
  tdLeft: {
    border: '1px solid #dee2e6',
    padding: '12px',
    verticalAlign: 'middle',
    textAlign: 'left',
  },
  productThumb: {
    width: '50px',
    height: 'auto',
    marginRight: '8px',
    verticalAlign: 'middle',
  },
  productLink: {
    textDecoration: 'none',
    color: '#0d6efd',
    verticalAlign: 'middle',
  },
  badgeSuccess: {
    display: 'inline-block',
    background: '#198754',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  badgeDanger: {
    display: 'inline-block',
    background: '#dc3545',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  inlineForm: {
    display: 'inline',
    margin: 0,
    padding: 0,
  },
  inlineLinkBtn: {
    border: 'none',
    background: 'transparent',
    padding: 0,
    margin: 0,
    fontSize: '12px',
    color: '#000',
    cursor: 'pointer',
    textDecoration: 'none',
  },
  primaryOutlineBtn: {
    display: 'inline-block',
    marginTop: '12px',
    padding: '8px 12px',
    border: '1px solid #0d6efd',
    color: '#0d6efd',
    textDecoration: 'none',
    borderRadius: '6px',
  },
};

export default SellerOrderView;